import React from 'react';

import LinkifiedText from '../../../shared/LinkifiedText/LinkifiedText';
import Button from '../../buttons/Button/Button';
import './HomeServiceCard.css';

const HomeServiceCard = ({ src, descTitle, leftDesc, link, title }) => {
  return (
    <div className='home-service-card-container'>
      <div
        style={{ backgroundImage: `url("${src}")` }}
        className='home-service-card-img-container'
      >
        <div className='home-service-card-desc-container'>
          {descTitle && (
            <h4 className='home-service-card-desc-title'>{descTitle}</h4>
          )}
          {leftDesc && (
            <p className='home-service-card-desc-content'>
              <LinkifiedText>{leftDesc}</LinkifiedText>
            </p>
          )}
          <div className='home-service-card-desc-btn-container'>
            {link && (
              <Button size='small' href={link}>
                Book Appointment
              </Button>
            )}
          </div>
        </div>
      </div>
      <div className='home-service-card-img-title'>{title}</div>
    </div>
  );
};

export default HomeServiceCard;
